// --------------
// Sizing
// --------------

// should roughly map to button/input etc height at each level
// fonts should match that height/lineHeight at each stop
// so these are really non-linear on purpose
export const sizeTokens = {
    0: 0,
    0.25: 2,
    0.5: 4,
    0.75: 6,
    1: 8,
    1.5: 14,
    2: 20,
    2.25: 22,
    2.75: 28,
    3: 32,
    4: 40,
    true: 40,
    4.5: 44,
    4.75: 48,
    5: 52,
    6: 60,
    7: 74,
    8: 80,
    9: 94,
    10: 104,
};

// A custom function to convert the concept of size to the concept of space
function sizeToSpace(v: number) {
    if (v <= 20) return Math.round(v * 0.333);
    return Math.floor(v * 0.7 - 12);
}

// --------------
// Spacing
// --------------

const spaceTokens = { 0: 0 };
Object.entries(sizeTokens)
    .slice(1)
    .forEach(([k, v]) => {
        const space = sizeToSpace(v);
        spaceTokens[k] = space;
        spaceTokens[`-${k}`] = -space;
    });

export { spaceTokens };

// --------------
// Radius
// --------------

export const radiusTokens = {
    0: 0,
    1: 2,
    2: 4,
    3: 8,
    true: 8,
    4: 12,
    5: 20,
    6: 50,
};

// --------------
// Icon sizing
// --------------
// TODO Figure out icon sizes and if these work
export const iconSizeTokens = {
    sm: 16,
    md: 24,
    lg: 32,
};
